<template>
  <el-form
    status-icon
    label-width="120px"
    class="add-slot-val"
    @submit.native.prevent
  >
    <el-form-item :label="`${labelName}：`" prop="pass">
      <el-input
        placeholder="请输入内容"
        class="input-with-select"
        :value="searchInfo"
        @input="onSearchChange"
      >
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="onSearch"
        ></el-button>
      </el-input>
    </el-form-item>
    <el-form-item class="add-input-contaienr">
      <div
        class="input-container"
        v-for="(item, index) in dataList"
        :key="index"
      >
        <el-input
          type="textarea"
          autosize
          :value="getInput(item)"
          @input="(e) => onInputChange(e, index)"
        ></el-input>
        <i class="el-icon-circle-close" @click="deleteInput(index)"></i>
      </div>

      <div class="add-input" @click="addInput">
        <i class="el-icon-plus"></i>
      </div>
    </el-form-item>
  </el-form>
</template>

<script>
  export default {
    props: {
      labelName: String,
      dataList: Array,
      searchInfo: String,
    },
    computed: {
      getInput: {
        get: function () {
          return (item) => {
            return this.labelName == '槽值取值'
              ? item.slot_val
              : this.labelName == '转人工号码'
              ? item.value
              : item.question
          }
        },
      },
    },
    methods: {
      onSearchChange(e) {
        this.$emit('onSearchChange', e)
      },
      onSearch() {
        this.$emit('my-search', this.searchInfo)
      },
      deleteInput(index) {
        this.$confirm('确定删除吗？').then((res) => {
          if (res == 'confirm') {
            this.$emit('my-delete', index)
          }
        })
      },
      addInput() {
        this.$emit('my-add')
      },
      onInputChange(e, index) {
        this.$emit('my-input', e, index)
      },
    },
  }
</script>

<style lang="scss">
  .add-slot-val {
    .add-input {
      width: calc(100% - 58px);
      text-align: center;
      border: 1px solid #dcdfe6;
      border-radius: 5px;
      box-sizing: border-box;
      cursor: pointer;
    }
    .add-input-contaienr {
      width: calc(100% + 38px);
      max-height: 300px;
      overflow-y: scroll;
    }
    .input-container {
      padding-right: 18px;
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }
    .el-icon-circle-close:before {
      margin-left: 10px;
      font-size: 30px;
      color: red;
    }
    .el-form-item__label {
      font-size: 16px;
    }
    .el-input {
      max-width: 100%;
    }
  }
</style>
